import http from './http.service';

class LangService {
    constructor() {
        // this.$http = http;
        this.baseUrl = "/api/lang";
    }

    get(lang) {
        if (!lang) {
            throw new Error('Language param is required');
        }

        return http.get(`${this.baseUrl}/get/${lang}`);
    };

    getLanguagesContents() {
        return http.get(`${this.baseUrl}/getLanguagesContents`);
    }

    saveJsLocalizationFiles(model) {
        return http.post(`${this.baseUrl}/saveJsLocalizationFiles`, model);
    }
}

export default new LangService();
